// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-home-index-js" + "-" + "eafdd88cc55991d0d0c2" + ".js";
};